export const MAP_LAYER_TRANSITION_MESSAGE = "mapLayerTransition";

/**
 * Check if a layer's constraints match the current filter selection.
 * Returns true only if ALL filter levels defined in the layer match current filters.
 */
export const doesLayerMatchCurrentFilters = (layer, currentFilters) => {
  if (!layer.constraints) return false;

  // Dynamically check ALL filter levels stored in the layer's constraints
  const filterLevels = Object.keys(layer.constraints);
  if (filterLevels.length === 0) return false;

  // Every filter level must be defined in currentFilters AND match the layer's constraints
  return filterLevels.every((level) => {
    const currentValue = currentFilters[level];
    const constraintValue = layer.constraints[level];
    return (
      currentValue &&
      constraintValue &&
      currentValue.toUpperCase() === constraintValue.toUpperCase()
    );
  });
};

/* Get busy layers (updating) */
export const getBusyLayers = (
  relevantLayers,
  exportPendingCount,
  busyBecauseView = false
) => {
  return relevantLayers.filter((l) => {
    const arcgisUpdating = Boolean(l.layer?.updating);
    if (arcgisUpdating) return true;

    // Wrapper flags can lag behind reality. Use them only while an export is
    // pending and the map is actively updating.
    if (exportPendingCount <= 0 || !busyBecauseView) return false;

    const unresolvedLoad = !l.loaded;
    const wrapperUpdating = Boolean(l.updating);
    return unresolvedLoad || wrapperUpdating;
  });
};

/**
 * Generate unique, non-empty layer names for display.
 */
export const getUniqueLayerNames = (layers) => {
  return [
    ...new Set(
      layers
        .map((l) => l.displayName || l.name)
        .filter((name) => name && typeof name === "string" && name.trim())
    ),
  ];
};

/** Generate busy text for tooltip */
export const getBusyText = (busyLayers) => {
  const uniqueNames = getUniqueLayerNames(busyLayers);

  if (uniqueNames.length === 0) {
    // Layers are busy but have no valid display names
    return busyLayers.length > 0 ? "Raster wird geladen..." : "";
  }

  if (uniqueNames.length === 1) return `${uniqueNames[0]} wird geladen`;
  return `${uniqueNames.join(", ")} werden geladen`;
};

/** Generate error text for tooltip */
export const getErrorText = (errorLayers) => {
  if (errorLayers.length === 0) return "";
  if (errorLayers.length === 1)
    return errorLayers[0].name + " konnte nicht geladen werden";
  return (
    errorLayers.map((l) => l.name).join(", ") + " konnten nicht geladen werden"
  );
};
